import { render } from "./FormsComponent.vue?vue&type=template&id=ccdc1d5e"
import script from "./FormsComponent.vue?vue&type=script&lang=js"
export * from "./FormsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__